import { ExtensionButton } from './ExtensionButton'

import { getExtUrl, openLink } from 'modules'

export const InstallExtButton = () => (
    <ExtensionButton onClick={browserType => openLink(getExtUrl(browserType))} />
)
